import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDot = styled.button.attrs(({ type = 'button' }) => ({ type }))`
  box-sizing: border-box;
  padding: 0;
  transition: all 250ms ease;
  border: 1px solid #a69991;
  margin: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.border.fur : 'transparent'};
  content: '';
  height: ${({ theme }) => theme.spacing(4)};
  width: ${({ theme }) => theme.spacing(4)};
  box-shadow: none;
  border-radius: 50%;
  outline: none;
  &:hover,
  &:focus {
    cursor: pointer;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border.fur};
  }
`;

export const Dot = ({ label, isActive, onClick }) => {
  return <StyledDot onClick={onClick} isActive={isActive} aria-label={label} />;
};

Dot.displayName = 'Dot';

Dot.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
